
export default class OlMapPlugin {

    constructor(options) {
        this._options = options || {};
    }

    getOlMap() {
        return this._options.olMap;
    }

    getMap() {
        return this.getOlMap().getMap();
    }

    init() {
        // nop;
    }
}
